module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("As any writer will tell you, behind every book is a team of people who labor to bring it into the world. My team happens to be an especially stellar one. Thanks to my brilliant agent, Jill Marr, for seeing something in these pages that prompted the most exciting voicemail of my life. Alexander Sehulster at St. Martin’s Press has been my eagle-eyed editor; her insights mixed with generous praise made the process a dream. A big thanks to everyone at St. Martin’s Press for your enthusiasm and energy. Major kudos to the team at Macmillan Audio: Robert Allen, Laura Wilson, Samantha Edelson, Danielle Prielipp, Brisa Robinson, and Mary Beth Roche.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Early readers provided me with much needed perspective: Matt and Kristin Hills, Bart Rawlinson, Rose Bell, David Wolf, Ginny Buccelli, Sherry Garner, and Ed Gehrman. You all helped me see exactly where this train went off the rails, and how to get her back on. Without you I’m a myopic mess.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Thanks to my collaborators and co-writers on other projects who indulged my obsession with this one: Wendy Goody, Kate Morein, Alexis Alex, and Naomi Wolf.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Most of all, thanks to my husband, David Wolf, who ordered me in no uncertain terms to drop everything and write this book. Your urgent faith is more precious to me than any words can express.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01ac2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0